import templateStr from 'text!./templates/claim-invoices.html';
import _ from 'lodash';
import BaseCtrl from 'edge/platform/base/BaseCtrl';
import ApplicationFeatures from 'gw-portals-featuredetection-js/ApplicationFeatures';

export default [() => {
    return {
        template: templateStr,
        $scope: {
            invoiceDetailsPromise: '=',
            claimDetailsPromise: '=',
            notes: '=',
            onNewNote: 'createInvoice()',
            emptyListMessage: '@emptyMessage',
            createLabel: '@createLabel',
            showAddNoteBtn: '@showAddNoteBtn'
        },
        controller: ['$scope', 'InsuranceSuiteMetadata', 'httpSettings', '$window', '$q', 'ModalService', 'claim.DocumentService', 'StateUtils', 'UserService', '$stateParams', 'claim.ClaimService', 'claim.endpointConfig', 'ViewModelService', 'servicerequest.ServiceRequestService', '$filter', '$state', ($scope, InsuranceSuiteMetadata, httpSettings, $window, $q, ModalService, DocumentService, StateUtils, UserService, $stateParams, ClaimService, endpointConfig, ViewModelService, ServiceRequestService, $filter, $state) => {
            const ctrl = Object.create(BaseCtrl);

            // type lists
            const serviceRequestInvoiceStatusTypeList = InsuranceSuiteMetadata.get('cc').types.getTypelist('ServiceRequestInvoiceStatus');
            const claimStateTypeList = InsuranceSuiteMetadata.get('cc').types.getTypelist('ClaimState');
            const documentTypeList = InsuranceSuiteMetadata.get('cc').types.getTypelist('DocumentType');

            // type codes
            const invoiceDocumentType = InsuranceSuiteMetadata.get('cc').types.getTypelist('DocumentType').getCode('invoice_psa').code;
            const codeInvoiceDocumentType = documentTypeList.getCode('invoice_psa').code;
            const codeWaitingForApproval = serviceRequestInvoiceStatusTypeList.getCode('waitingforapproval').code;
            const codeInvoiceWithdrawn = serviceRequestInvoiceStatusTypeList.getCode('withdrawn').code;
            const codeInvoiceRejected = serviceRequestInvoiceStatusTypeList.getCode('rejected').code;
            const codeInvoiceApproved = serviceRequestInvoiceStatusTypeList.getCode('approved').code;
            const codeCheckCreated = serviceRequestInvoiceStatusTypeList.getCode('checkcreated').code;
            const claimOpen = claimStateTypeList.getCode('open').code;
            const claimClosed = claimStateTypeList.getCode('closed').code;

            //variables
            $scope.claimOpenStatus = claimOpen;
            $scope.claimClosedStatus = claimClosed;
            $scope.waitingForApproval = codeWaitingForApproval;
            $scope.withdrawn = codeInvoiceWithdrawn;
            $scope.rejected = codeInvoiceRejected;
            $scope.approved = codeInvoiceApproved;
            $scope.checkCreated = codeCheckCreated;

            // data sharing
            const invoice = {
                'referenceNumber': '',
                'creationDate': '',
                'invoiceAmountWithoutVat':'',
                'invoiceVatAmount':'',
                'invoiceTotalAmount': '',
                'totalAmount': {},
                'vatamount': {},
                'amountWithoutVAT': {},
                'description': '',
                'existingDocumentsToLink': [],
                'status': codeWaitingForApproval,
            };

            // DTOs
            $scope.invoice = ViewModelService.create(invoice, 'cc', 'edge.capabilities.servicerequest.statement.invoice.dto.ServiceRequestInvoiceDTO');

            $scope.claimDetailsPromise.then(function (result) {
                $scope.claimStatus = result.claimState;
                $scope.showDeleteButton = false;
                $scope.canAddInvoiceToServiceRequest = result.canAddInvoiceToServiceRequest;
                $scope.serviceRequests = result.serviceRequests || [];
                $scope.serviceRequestID = result.serviceRequestID;
                $scope.policy = result.policy;

                const germanProducts = ["ucw_gvo_de", "ucw_egvo_de", "ec_egvn_de"];
                $scope.isGermanPolicy = false;
                if (germanProducts.includes($scope.policy.productCode)){
                    $scope.isGermanPolicy = true;
                }

                //invoice details for portal to display in invoice tab
                if (result.portalSRInvoiceDetails != null) {
                    $scope.referenceNumber = result.portalSRInvoiceDetails.referenceNumber;
                    if (result.portalSRInvoiceDetails.creationDate != null) {
                        var date = new Date(result.portalSRInvoiceDetails.creationDate);
                        $scope.creationDate = date.toISOString().split('T')[0];
                    }
                    $scope.amountWithoutVat = result.portalSRInvoiceDetails.amountWithoutVAT;
                    $scope.vatAmount = result.portalSRInvoiceDetails.vatamount;
                    $scope.altteilsteurAmount = result.portalSRInvoiceDetails.altteilsteurAmount;
                    $scope.totalAmount = result.portalSRInvoiceDetails.totalAmount;

                    $scope.invoiceStatus = result.portalSRInvoiceDetails.statusCode;
                    $scope.invoiceStatusName = result.portalSRInvoiceDetails.statusName;
                    $scope.invoiceStatusDesc = result.portalSRInvoiceDetails.statusDesc;
                    $scope.invoiceDocPublicId = result.portalSRInvoiceDetails.invoiceDocPublicId;
                }
                // documents
                const filteredDocuments = result.documents.filter((doc) => {
                    if (doc.documentType === 'invoice_psa' && $scope.invoiceDocPublicId != null
                        && doc.publicID == $scope.invoiceDocPublicId) {
                        return true;
                    }
                });
                $scope.documents = filteredDocuments || [];

                if (result.invoiceNumberForPortal != undefined &&
                    result.invoiceNumberForPortal != null &&
                    $scope.invoiceStatus == codeWaitingForApproval
                    && $scope.invoiceDocPublicId != null) {
                    $scope.showDeleteButton = true;
                }
            });

            $scope.today = new Date();
            $scope.claimNumber = $stateParams.claimNumber;
            // data sharing with FileUploadViewer
            $scope.removeFunction = function (documentID) {
                DocumentService.removeDocument($scope.claimNumber, documentID).then(
                    () => {
                        ModalService.showInfo('claim.directives.templates.claim-invoice.Invoice deleted successfully', 'claim.directives.templates.claim-invoice.Invoice deleted successfully'),
                            setTimeout(() => { }, "2000"),
                            location.reload()
                    },
                    (error) => {
                        ModalService.showError(
                            'claim.directives.templates.claim-invoice.Invoice deletion failed',
                            $q.when(error)
                        );
                    }
                )
            };

            $scope.metadataTemplate = {
                'DocUID': '001',
                'DocumentType': 'fnol',
                'SecurityType': 'unrestricted',
                'Status': 'approved',
                'Author': 'Repairer',
                'claimNumber': $scope.claimNumber
            };

            $scope.claimCenterDownloadURI = httpSettings.serviceBaseURLs.cc + endpointConfig.downloadEndpoint;
            $scope.documentNotFoundURL = `${$window.location.pathname.substring(0, window.location.pathname.lastIndexOf('/'))}/ServiceRequestDocumentError`;
            $scope.uploadConfig = {
                htmlFile: 'claim-invoice.html',
                invoice: $scope.invoice,
                documents: $scope.documents,
                metadataTemplate: $scope.metadataTemplate,
                documentNotFoundUrl: $scope.documentNotFoundURL,
                canAddInvoiceToServiceRequest: $scope.canAddInvoiceToServiceRequest,
                xcenterCenterRetrievalUrl: $scope.claimCenterDownloadURI,
                documentUpload: 'cc',
                serviceName: endpointConfig.uploadEndpoint,
                sessionServiceName: endpointConfig.sessionServiceName,
                // Adding random number at end to make the class unique (multiple uploads on the page)
                uploaderClass: `gw-claim-common-file-upload-button${Math.floor(Math.random() * 9999)}`
            };

        }]
    };
}];
